var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agendamento-microfront"},[_c('router-view'),_c('notifications',{attrs:{"group":"global","position":"bottom right","duration":4000}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }